import { Injectable } from '@angular/core';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { Command } from '../../../core/model/command';
import { leaseAgreementCommand } from '../../command/lease-agreement.command';
import { ContractService } from '../base/contract';
import { MessageService } from '../../../core/service/message.service';
import { Contract } from '../../model/contract';
import { Subject, Observable } from 'rxjs';

@Injectable()
export class WithdrawTerminationCommandHandler implements ICommandHandler {
  constructor(
    private _service: ContractService<Contract>,
    private _messageService: MessageService
  ) {}

  private _resultSubject = new Subject<boolean>();

  canExecute(command: Command): boolean {
    return command.id === leaseAgreementCommand.withdrawTermination;
  }
  execute(command: Command): Observable<boolean> {
    this._messageService.showDialog('LEASE_AGREEMENT.WITHDRAW_TERMINATION.CONFIRM').subscribe(confirmed => {
      if (!confirmed) {
        this._resultSubject.next(false);
        return;
      }

      this._service.withdrawTermination(command.context.id).subscribe(
        result => {
          if (command.context instanceof Contract) {
            command.context.status = result.status;
            command.context.lastBillingDate = null;
            command.context.noticePeriod.lastDebit = null;
            this._resultSubject.next(true);
          }
          this._messageService.showSuccess();
        },
        error => {
          this._resultSubject.next(false);
          this._messageService.showError(error);
        }
      );
    });

    return this._resultSubject.asObservable();
  }
}
